import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-trafik-panel',
  templateUrl: './trafik-panel.component.html',
  styleUrls: ['./trafik-panel.component.css']
})
export class TrafikPanelComponent {
  @Input() remainingTraffic: string = '0';
  @Input() totalTraffic: string = '0';

  constructor(private router: Router) {
  }

  private parseGBValue(value: string): number {
    // Remove 'GB' and trim whitespace, then parse to float
    return parseFloat(value.replace(/GB/gi, '').trim());
  }

  private formatGBValue(value: number): string {
    return `${value.toFixed(2)} GB`;
  }

  get usedTraffic(): string {
    const remaining = this.parseGBValue(this.remainingTraffic);
    const total = this.parseGBValue(this.totalTraffic);
    const used = total - remaining;
    return this.formatGBValue(used);
  }

  get progressValue(): number {
    const remaining = this.parseGBValue(this.remainingTraffic);
    const total = this.parseGBValue(this.totalTraffic);
    return total > 0 ? (remaining / total) * 100 : 0;
  }

  get progressMax(): number {
    return 100;
  }

  goToSubscription() {
    this.router.navigate(['subscription']);
  }
}
